import script from "./Subtitle.vue?vue&type=script&setup=true&lang=js"
export * from "./Subtitle.vue?vue&type=script&setup=true&lang=js"

import "./Subtitle.vue?vue&type=style&index=0&id=792cad20&lang=css"

const __exports__ = script;

export default __exports__